// Métodos de depósito que NÃO debitam de conta bancária: neles o consentimento
// de cadastro da conta (`save_bank_account`) não faz sentido e a caixa some.
// Lista espelhada do fluxo principal (components/deposit/DefaultLayout.vue) —
// PIX não está nela, então na tela de jogo o consentimento sempre aparece.
const NON_BANK_ACCOUNT_DEPOSIT_METHODS = [
  'spei',
  'oxxo',
  'astropay',
  'worldline',
  'credit-card',
  'prontopaga',
];

export function isBankAccountDepositMethod(method: string): boolean {
  return !NON_BANK_ACCOUNT_DEPOSIT_METHODS.includes(method);
}
